import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pagination-nav text-center mt_50" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-angle-double-left" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-angle-left" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-angle-right" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-angle-double-right" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_page = _resolveComponent("v-page")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      (!_ctx.hideFirstButton)
        ? (_openBlock(), _createElementBlock("li", _hoisted_2, [
            _createElementVNode("a", {
              class: _normalizeClass({ 'active': _ctx.isPrevControlsActive }),
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToFirst && _ctx.goToFirst(...args)))
            }, _hoisted_4, 2)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("li", null, [
        _createElementVNode("a", {
          class: _normalizeClass({ 'active': _ctx.isPrevControlsActive }),
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goToPrev && _ctx.goToPrev(...args)))
        }, _hoisted_6, 2)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagination, (page) => {
        return (_openBlock(), _createBlock(_component_v_page, {
          key: `pagination-page-${page}`,
          page: page,
          current: _ctx.modelValue,
          "active-color": _ctx.activeColor,
          onUpdate: _ctx.updatePageHandler
        }, null, 8, ["page", "current", "active-color", "onUpdate"]))
      }), 128)),
      _createElementVNode("li", null, [
        _createElementVNode("a", {
          class: _normalizeClass({ 'active': _ctx.isNextControlsActive }),
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goToNext && _ctx.goToNext(...args)))
        }, _hoisted_8, 2)
      ]),
      (!_ctx.hideLastButton)
        ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
            _createElementVNode("a", {
              class: _normalizeClass({ 'active': _ctx.isNextControlsActive }),
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goToLast && _ctx.goToLast(...args)))
            }, _hoisted_11, 2)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}